
export class ResourceUtil {
    public asset(url: string) {
        return `/${url}`;
    }
}